import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from 'planning-portal-library/src/lib/core/domain';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { ProductPortalRepository } from 'planning-portal-library/src/lib/core/repositories';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { BaseResponse } from '../../../shared/base.response';
import { ProductsWebRepositoryMapper } from './entities';
import { ProductPortalApiUrls } from './product-portal-api-urls';
@Injectable({ providedIn: 'root' })
export class ProductPortalWebRepository extends ProductPortalRepository {
  private readonly productMapper = new ProductsWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getProducts(): Observable<Product[]> {
    return this.http
      .get<BaseResponse<Product[]>>(
        `${this.environment.url}${ProductPortalApiUrls.GetProducts}`
      )
      .pipe(
        mergeMap((response) =>
          response.result!.sort((a, b) =>
            a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
          )
        ),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.productMapper.mapFrom))
      .pipe(reduce((items: Product[], item: Product) => [...items, item], []));
  }
}
